import { createContext, useContext, useMemo, useRef } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { getAboutus, updateAboutus } from "../../api/home";
import { getFaqs } from "../../api/faq";

import { generatePayload, getIntialValues } from "./helper";
const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const trainersArrayRef = useRef();
  const believesArrayRef = useRef();
  const monialsRef = useRef();
  const toaster = useToaster();

  const getAboutQuery = useQuery({
    queryKey: [""],
    queryFn: getAboutus,
  });

  const getFaqQuery = useQuery({
    queryKey: [{ limit: 200 }],
    queryFn: getFaqs,
  });

  const updateAboutQuery = useMutation({ mutationFn: updateAboutus });

  const initialValues = useMemo(() => {
    const homeData = getAboutQuery?.data?.data?.data?.[0] || {};

    return getIntialValues(homeData.page_content);
  }, [getAboutQuery]);

  const handleSubmit = async (values) => {
    const payload = generatePayload(values);
    const homeData = getAboutQuery?.data?.data?.data?.[0] || {};

    updateAboutQuery.mutate(
      { page_content: payload, id: homeData.id },
      {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
          getAboutQuery.refetch();
        },
      },
    );
    return;
  };

  const handleTrainerAdd = () => {
    trainersArrayRef.current?.push({
      label: "",
      count: "",
      image_link: "",
    });
  };
  const handleTrainerDelete = (index) => () => {
    trainersArrayRef.current?.remove(index);
  };

  const handleBeliefAdd = () => {
    believesArrayRef.current?.push({
      image_link: "",
      label: "",
      description: "",
      alt_tag:"",
    });
  };

  const handleBeliefDelete = (index) => () => {
    believesArrayRef.current?.remove(index);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,
        getAboutQuery,
        handleTrainerAdd,
        handleTrainerDelete,
        trainersArrayRef,
        believesArrayRef,
        handleBeliefAdd,
        handleBeliefDelete,
        monialsRef,
        getFaqQuery,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};
export const usePageProvider = () => {
  return useContext(PageContext);
};
